<template>
	<div>
		<div class="FileAddImg">
			<div class="fileName" :title="fileAddImgData.FileName">
				{{fileAddImgData.FileName}}
			</div>
			<div class="cz">
				<div v-if="SeeFlag" class="fileSee fileCz" @click="See(fileAddImgData)">查看</div>
				<div v-if="DelFlag" class="fileDel fileCz" @click="Del(fileAddImgData,index)">删除</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			fileAddImgData: {
				type: Object
			},
			index: {
				type: Number
			},
			SeeFlag: {
				type: Boolean,
				default: true
			},
			DelFlag: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			See(fileAddImgData) {
				this.$emit('See', fileAddImgData)
			},
			Del(fileAddImgData, index) {
				let Obj = {
					fileAddImgData,
					index
				}
				this.$emit('Del', Obj)
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.FileAddImg {
		line-height: 32px;
		border-radius: 2px;
		border: 1px solid rgb(230 230 230);
		cursor: pointer;
		display: inline-block;
		position: relative;
		width: 440px;
		height: 32px;
		color: rgb(0 0 0);
		font-size: 12px;
		background-color: rgb(250 251 252);
		flex-wrap: wrap;
		margin-top: 10px;

		.fileName {
			display: inline-block;
			font-size: 14px;
			margin-left: 20px;
			max-width: 320px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		.cz {
			width: 90px;
			display: flex;
			font-size: 14px;
			float: right;
			color: rgb(231 29 67);

			.fileCz {
				display: inline-block;
				margin-left: 10px;
			}
		}
	}
</style>